/**
 * Search Store Constants
 *
 * Constants for search-related functionality. The active search tag cap is
 * `getMaxStreamTags()`, shared with the URL parser so chips and results agree.
 */

/** Maximum number of recent searches to store per type (users or tags) */
export const MAX_RECENT_SEARCHES = 5;
